import { JDSTableCellProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSTableCellProps>
  ): React.FC<JDSTableCellProps> =>
  (props: JDSTableCellProps) => {
    return (
      <Component
        {...{
          ...props,
          _role: props.type === 'header' ? 'columnheader' : 'cell'
        }}
      />
    );
  };
